import { LactateFormValues } from '../formModel';

// A lactate test is a long, single-page form. We persist an in-progress draft
// per client to localStorage so an accidental reload, tab sleep, or navigation
// away doesn't wipe everything the coach has typed. The draft is cleared once a
// report generates successfully. All access is best-effort: private-mode or
// quota errors must never break data entry.

const keyFor = (clientId: string): string => `lactate-draft:${clientId}`;

export function loadDraft(clientId: string): LactateFormValues | null {
  try {
    const raw = window.localStorage.getItem(keyFor(clientId));
    if (!raw) return null;
    return JSON.parse(raw) as LactateFormValues;
  } catch {
    return null;
  }
}

export function saveDraft(clientId: string, values: LactateFormValues): void {
  try {
    window.localStorage.setItem(keyFor(clientId), JSON.stringify(values));
  } catch {
    /* storage unavailable (private mode / quota) — draft is best-effort */
  }
}

export function clearDraft(clientId: string): void {
  try {
    window.localStorage.removeItem(keyFor(clientId));
  } catch {
    /* ignore */
  }
}
